import Model, { attr, hasMany } from "@ember-data/model";
import type BioExamReportTemplate from "parog-web/models/bio-exam-report-template";
import type Loinc from "./loinc";
import { type Specimen } from "./loinc";

export default class BioExamOrder extends Model {
  @attr("string") declare loinc: string;
  @attr("string") declare label: string;
  @attr("string") declare loincType: string;
  @attr() declare nabm: string[];
  @attr("string") declare customLabel: string | null;
  @attr("string") declare shortenedLabel: string | null;
  @attr("string") declare unit: string | null;
  @attr("string") declare loincChapter: string | null;
  @attr("string") declare loincChapterLabel: string;
  @attr("string") declare specimen: Specimen | null;

  @hasMany("bio-exam-report-template", {
    async: false,
    inverse: "bioExamOrders"
  })
  declare bioExamReportTemplates: BioExamReportTemplate[];

  @hasMany("loinc", {
    async: false,
    inverse: "bioExamOrder"
  })
  declare bioExamObservations: Loinc[];

  /**
   * Return `customLabel` if set ot `label`.
   */
  get longLabel(): string {
    return this.customLabel || this.label;
  }

  /**
   * Return `shortenedLabel` if set or `longLabel`.
   */
  get shortLabel(): string {
    return this.shortenedLabel || this.longLabel;
  }
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "bio-exam-order": BioExamOrder;
  }
}
